import React from 'react'
import { Box, Button, Text, useResponsiveValue } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

type Props = {
  onApply: () => void
}

const ApplicationCard = ({ onApply }: Props) => {
  const { t } = useTranslation()
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false,
    desktop: false
  })

  return (
    <Box
      borderRadius="large"
      display="flex"
      flexDirection="column"
      style={{
        boxShadow:
          '0px 4px 6px -2px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04)',
        padding: '24px',
        border: '1px solid #E0E0E0',
        gap: '24px'
      }}
    >
      <Text size="xlarge" weight="strong" tone="neutral">
        {t(
          'b.listing.application.card.title',
          'Interested? Secure this home by sending your application today'
        )}
      </Text>
      <Button variant="ghost" onClick={onApply}>
        {isMobile
          ? t('b.listing.application.card.button', 'Apply Now')
          : t(
              'b.listing.application.card.button.desktop',
              'Start your application'
            )}
      </Button>
    </Box>
  )
}

export default ApplicationCard
